import { useEffect, useState } from "react";
import api from "../../lib/api";

const STATUS = {
  active: ["Activa", "bg-[#22C55E]/12 text-[#15803D]"],
  trialing: ["Prueba", "bg-[#6FA2DE]/15 text-[#3B6FB0]"],
  past_due: ["Pago pendiente", "bg-[#F59E0B]/15 text-[#B45309]"],
  courtesy: ["De por vida", "bg-[#9A8BEA]/15 text-[#6D5BD0]"],
  canceled: ["Cancelada", "bg-black/[0.06] text-black/55"],
};
const money = (v) => (v == null ? "—" : `US$${v.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`);
const date = (iso) => (iso ? new Date(iso).toLocaleDateString("es-ES", { day: "numeric", month: "short", year: "numeric" }) : "—");

const Kpi = ({ label, value, hint, testid }) => (
  <div className="rounded-[22px] bg-white/15 border border-white/25 p-4" data-testid={testid}>
    <div className="text-[10px] uppercase tracking-[0.18em] text-white/80">{label}</div>
    <div className="mt-1 text-[26px] font-semibold text-white leading-none">{value}</div>
    {hint && <div className="mt-1.5 text-[11.5px] text-white/80">{hint}</div>}
  </div>
);

export const AiRevenueCard = () => {
  const [d, setD] = useState(null);
  useEffect(() => {
    api.get("/admin/ai-revenue").then(({ data }) => setD(data)).catch(() => setD(false));
  }, []);
  if (d === false) return null;
  const c = d?.counts || {};

  return (
    <div className="space-y-3" data-testid="admin-ai-revenue">
      <div className="cai-panel relative overflow-hidden rounded-[28px] p-5">
        <div className="relative z-10">
          <div className="flex items-center justify-between flex-wrap gap-2 mb-4 text-white">
            <div>
              <div className="text-[15px] font-semibold">ConsuDoctor AI · Ingresos</div>
              <div className="text-[12px] text-white/80">Suscripción mensual de {money(d?.price)} por doctor</div>
            </div>
          </div>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
            <Kpi testid="ai-kpi-active" label="Suscriptores activos" value={d ? c.active : "…"} hint={d && c.canceling ? `${c.canceling} cancelan al final del periodo` : "Pagando cada mes"} />
            <Kpi testid="ai-kpi-trial" label="En prueba gratis" value={d ? c.trialing : "…"} hint={d && `${c.courtesy} de por vida${d.lifetime_total ? ` · ${money(d.lifetime_total)} cobrado por fuera` : ""}`} />
            <Kpi testid="ai-kpi-mrr" label="Ingreso mensual" value={d ? money(d.mrr) : "…"} hint={d && `${money(d.projected_mrr)} si las pruebas pagan`} />
            <Kpi testid="ai-kpi-collected" label="Cobrado 30 días" value={d ? money(d.collected_30d) : "…"} hint={d && c.past_due ? `${c.past_due} con pago pendiente` : "Pagos confirmados en Stripe"} />
          </div>
        </div>
      </div>
      {d?.subscribers?.length > 0 && (
        <div className="bg-white rounded-[28px] border border-black/[0.06] overflow-hidden" data-testid="ai-subscribers">
          <table className="w-full text-[13px]">
            <thead>
              <tr className="text-left text-[10.5px] uppercase tracking-widest text-black/45">
                <th className="px-5 py-3 font-semibold">Doctor</th>
                <th className="px-5 py-3 font-semibold">Email</th>
                <th className="px-5 py-3 font-semibold">Estado</th>
                <th className="px-5 py-3 font-semibold">Próximo cobro</th>
              </tr>
            </thead>
            <tbody>
              {d.subscribers.map((s) => {
                const [label, cls] = STATUS[s.status] || [s.status || "—", "bg-black/[0.06] text-black/55"];
                return (
                  <tr key={s.id} className="border-t border-black/[0.05]" data-testid={`ai-sub-row-${s.id}`}>
                    <td className="px-5 py-3 font-semibold text-black">
                      {s.name}
                      {s.specialty && <span className="font-normal text-black/45"> · {s.specialty}</span>}
                    </td>
                    <td className="px-5 py-3 text-black/65">{s.email}</td>
                    <td className="px-5 py-3">
                      <span className={`inline-flex px-2.5 h-6 items-center rounded-full text-[11px] font-semibold ${cls}`}>{label}</span>
                      {s.cancel_at_period_end && <span className="ml-2 text-[11px] text-black/45">cancela</span>}
                    </td>
                    <td className="px-5 py-3 text-black/65">{["active", "trialing"].includes(s.status) && !s.cancel_at_period_end ? date(s.renews_at) : "—"}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};
